(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3763],{

/***/ 44511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconDiscord = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.268 10.07c-.696 0-1.246.593-1.246 1.33 0 .74.562 1.332 1.246 1.332.695 0 1.245-.593 1.245-1.331s-.562-1.331-1.245-1.331zm-4.456 0c-.696 0-1.245.593-1.245 1.33 0 .74.561 1.332 1.245 1.332.696 0 1.245-.593 1.245-1.331.012-.738-.55-1.331-1.245-1.331z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20.2 0H3.842C2.463 0 1.34 1.113 1.34 2.481V18.7c0 1.368 1.123 2.481 2.502 2.481h13.844l-.647-2.215 1.562 1.428 1.477 1.344L22.715 24V2.481A2.514 2.514 0 0020.2 0zm-4.712 15.673s-.44-.52-.805-.968c1.599-.448 2.21-1.428 2.21-1.428a7.01 7.01 0 01-1.405.714 8.806 8.806 0 01-1.77.52 8.622 8.622 0 01-3.162-.012 9.349 9.349 0 01-1.794-.52 7.17 7.17 0 01-.891-.412c-.037-.024-.073-.036-.11-.06-.024-.012-.037-.024-.049-.024-.22-.121-.342-.206-.342-.206s.586.956 2.137 1.416c-.367.46-.818.992-.818.992-2.698-.084-3.723-1.827-3.723-1.827 0-3.861 1.757-6.996 1.757-6.996 1.758-1.295 3.418-1.258 3.418-1.258l.123.145c-2.198.617-3.199 1.573-3.199 1.573s.269-.145.72-.339c1.307-.568 2.344-.714 2.771-.762.074-.012.135-.024.208-.024a10.417 10.417 0 012.466-.025c1.16.134 2.405.472 3.674 1.15 0 0-.964-.907-3.04-1.525l.172-.193s1.672-.037 3.418 1.258c0 0 1.758 3.135 1.758 6.996 0-.012-1.026 1.73-3.724 1.815z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconDiscord, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 20570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconFacebook = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M24 12.073C24 5.405 18.628 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047v-2.66c0-3.025 1.79-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.971H15.83c-1.49 0-1.955.931-1.955 1.886v2.264h3.328l-.532 3.49h-2.796V24C19.613 23.095 24 18.1 24 12.073z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconFacebook, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 41749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconInstagram = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.995 2.162c3.205 0 3.581.014 4.848.071 1.171.053 1.805.248 2.228.415.562.219.962.476 1.381.895.42.419.681.819.896 1.38.162.425.361 1.058.414 2.23.057 1.266.071 1.642.071 4.847 0 3.205-.014 3.58-.071 4.848-.053 1.171-.248 1.804-.414 2.228a3.722 3.722 0 01-.896 1.381c-.419.42-.819.681-1.38.895-.424.162-1.058.362-2.23.415-1.266.057-1.642.071-4.847.071-3.205 0-3.58-.014-4.847-.071-1.172-.053-1.805-.248-2.229-.415a3.723 3.723 0 01-1.38-.895 3.664 3.664 0 01-.896-1.38c-.162-.425-.362-1.058-.414-2.23-.058-1.266-.072-1.642-.072-4.847 0-3.205.014-3.581.072-4.848.052-1.171.247-1.804.414-2.228.219-.562.476-.962.895-1.381a3.665 3.665 0 011.381-.895c.424-.162 1.057-.362 2.229-.415 1.266-.062 1.647-.071 4.847-.071zm0-2.162C8.738 0 8.33.014 7.048.071 5.77.13 4.9.333 4.138.63a5.847 5.847 0 00-2.124 1.385A5.95 5.95 0 00.63 4.138C.333 4.9.129 5.771.07 7.052.014 8.33 0 8.738 0 11.995c0 3.257.014 3.667.071 4.948.058 1.276.262 2.147.558 2.914.304.79.719 1.457 1.385 2.124a5.95 5.95 0 002.124 1.386c.762.295 1.633.5 2.914.557 1.281.057 1.686.071 4.948.071 3.262 0 3.667-.014 4.948-.071 1.276-.057 2.147-.262 2.914-.557a5.847 5.847 0 002.124-1.386 5.949 5.949 0 001.385-2.124c.296-.762.5-1.633.558-2.914.057-1.281.071-1.686.071-4.948 0-3.262-.014-3.666-.071-4.947-.058-1.277-.262-2.148-.558-2.915a5.846 5.846 0 00-1.385-2.123A5.95 5.95 0 0019.862.624c-.762-.295-1.633-.5-2.914-.557C15.662.014 15.252 0 11.995 0z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.995 5.838a6.163 6.163 0 10.002 12.326 6.163 6.163 0 00-.002-12.326zm0 10.157a4 4 0 110-7.999 4 4 0 010 8zM18.4 7.029a1.438 1.438 0 100-2.877 1.438 1.438 0 000 2.877z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconInstagram, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 85822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconReddit = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.528 16.093c-.535.535-1.692.728-2.507.728-.814 0-1.971-.193-2.507-.728a.31.31 0 00-.45 0 .31.31 0 000 .45c.857.857 2.486.921 2.979.921.471 0 2.121-.064 2.978-.921a.31.31 0 000-.45c-.171-.107-.385-.107-.493 0zM10.5 13.264a1.244 1.244 0 10-2.487.002 1.244 1.244 0 002.487-.002z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 0C5.379 0 0 5.379 0 12s5.379 12 12 12 12-5.379 12-12c.021-6.621-5.357-12-12-12zm6.964 13.607c.022.171.043.343.043.536 0 2.7-3.129 4.886-7.007 4.886-3.879 0-7.007-2.208-7.007-4.908 0-.171.021-.364.043-.535A1.755 1.755 0 014.007 12c0-.964.793-1.757 1.757-1.757.472 0 .9.193 1.222.493 1.221-.879 2.893-1.436 4.757-1.479l.9-4.178a.312.312 0 01.128-.193.298.298 0 01.236-.043l2.914.621c.215-.407.622-.707 1.115-.707a1.244 1.244 0 010 2.486 1.25 1.25 0 01-1.243-1.2l-2.614-.557-.793 3.75c1.843.064 3.493.621 4.692 1.478.322-.3.75-.493 1.222-.493.964 0 1.757.793 1.757 1.758-.043.75-.471 1.35-1.093 1.628z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.764 12a1.244 1.244 0 10.002 2.487A1.244 1.244 0 0014.764 12z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconReddit, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 95550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconSpecialPromotions = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.88 17.742l.12.008h20l.12-.008c.84-.11.84-1.375 0-1.484L22 16.25A2.25 2.25 0 0119.75 14V9a7.75 7.75 0 00-15.5 0v5a2.25 2.25 0 01-2.096 2.245L2 16.25c-.958 0-.998 1.378-.12 1.492zM12 2.75A6.25 6.25 0 0118.25 9v5l.005.2a3.73 3.73 0 00.675 1.954l.071.096H4.998l.072-.096c.428-.61.68-1.352.68-2.154V9A6.25 6.25 0 0112 2.75zm1.081 17.874a.75.75 0 111.298.752 2.75 2.75 0 01-4.758 0 .75.75 0 011.24-.837l.058.085a1.25 1.25 0 002.081.123l.081-.123z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconSpecialPromotions, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 73973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconTikTok = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M21.143 0H2.857A2.86 2.86 0 000 2.857v18.286A2.86 2.86 0 002.857 24h18.286A2.86 2.86 0 0024 21.143V2.857A2.86 2.86 0 0021.143 0zM18.86 10.47a4.28 4.28 0 01-3.977-1.916v6.593a4.872 4.872 0 11-4.873-4.873c.102 0 .202.01.302.016v2.4c-.1-.011-.199-.03-.302-.03a2.487 2.487 0 000 4.974c1.374 0 2.587-1.082 2.587-2.456l.024-11.196h2.297a4.279 4.279 0 003.944 3.82v2.668"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconTikTok, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 15598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconTwitch = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M5.99 0L1.7 4.286v15.428h5.147V24l4.29-4.286h3.431L22.29 12V0H5.99zm14.583 11.143l-3.431 3.428H13.71l-3.002 3v-3h-3.86V1.714h13.725v9.429z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18 4.714h-1.716v5.143H18V4.714zm-4.719 0h-1.715v5.143h1.715V4.714z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconTwitch, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 42579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconTwitter = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm6.024 9.726c.006.126.006.246.006.372 0 3.822-2.91 8.232-8.232 8.232a8.177 8.177 0 01-4.434-1.302 5.816 5.816 0 004.284-1.194 2.889 2.889 0 01-2.7-2.01 2.884 2.884 0 001.308-.048 2.891 2.891 0 01-2.322-2.838v-.036c.39.216.834.348 1.308.36a2.895 2.895 0 01-.9-3.858 8.208 8.208 0 005.964 3.024 2.894 2.894 0 014.926-2.64 5.859 5.859 0 001.836-.702 2.892 2.892 0 01-1.272 1.602 5.928 5.928 0 001.662-.456 5.657 5.657 0 01-1.434 1.494z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconTwitter, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 95649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconYouTube = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.495 6.145a3.038 3.038 0 00-2.127-2.14C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.382.505c-1.036.272-1.84 1.09-2.127 2.14C0 8.027 0 11.955 0 11.955s0 3.927.505 5.809a3.037 3.037 0 002.127 2.14C4.5 20.41 12 20.41 12 20.41s7.5 0 9.382-.505c1.036-.272 1.84-1.09 2.127-2.14.491-1.882.491-5.81.491-5.81s0-3.927-.505-5.809zm-13.95 9.382V8.382l6.273 3.572-6.273 3.573z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconYouTube, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 62504:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/[slug]",
      function () {
        return __webpack_require__(38866);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12918);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_error__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _nzxt_react_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2017);
/* harmony import */ var _components_Head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68368);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16119);
/* harmony import */ var _components_ContentWrapper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74733);
/* harmony import */ var _components_CollectionPage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60338);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28448);












var Loading = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nzxt_react_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        className: "loading-icon"
    });
};
var LoginView = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7536), __webpack_require__.e(8197)]).then(__webpack_require__.bind(__webpack_require__, 8197));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8197)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loading, {});
    }
});
var SignUpView = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7536), __webpack_require__.e(2181)]).then(__webpack_require__.bind(__webpack_require__, 92181));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92181)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loading, {});
    }
});
var ResetView = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7536), __webpack_require__.e(2718)]).then(__webpack_require__.bind(__webpack_require__, 72718));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72718)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loading, {});
    }
});
var ForgotView = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7536), __webpack_require__.e(6516)]).then(__webpack_require__.bind(__webpack_require__, 96516));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96516)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loading, {});
    }
});
var VerifyView = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 5585).then(__webpack_require__.bind(__webpack_require__, 85585));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85585)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loading, {});
    }
});
var ErrorView = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 261).then(__webpack_require__.bind(__webpack_require__, 20261));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20261)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loading, {});
    }
});
var Signout = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 3468).then(__webpack_require__.bind(__webpack_require__, 53468));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53468)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loading, {});
    }
});
var PostLogin = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7536), __webpack_require__.e(2952), __webpack_require__.e(7589), __webpack_require__.e(8985), __webpack_require__.e(9269), __webpack_require__.e(3437), __webpack_require__.e(485), __webpack_require__.e(6726), __webpack_require__.e(1675)]).then(__webpack_require__.bind(__webpack_require__, 55052));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55052)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loading, {});
    }
});
var Auth = function(param) {
    var baseUrl = param.baseUrl, page = param.page, termPages = param.termPages;
    var _useSession = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_5__.useSession)(), session = _useSession.data;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var query = router.query;
    var token = session === null || session === void 0 ? void 0 : session.accessToken;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var urlParams = new URLSearchParams(window.location.search);
        var callbackUrl = urlParams.get("callbackUrl") || "".concat("https://nzxt.com", "/user/settings");
        var isAllowed = new URL(callbackUrl).origin === "https://nzxt.com";
        if (token && isAllowed && (page === "signin" || page === "signup" || page === "reset-verification" || page === "forgot-password" || page === "email-verification")) {
            router.push(callbackUrl);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        token,
        page
    ]);
    return !page ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_error__WEBPACK_IMPORTED_MODULE_3___default()), {
        statusCode: 404
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Head__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                canonical: "".concat(baseUrl, "/").concat(_constants__WEBPACK_IMPORTED_MODULE_10__/* .ROUTE_AUTH */ .Myu, "/").concat(query.slug),
                baseUrl: baseUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CollectionPage__WEBPACK_IMPORTED_MODULE_9__/* .SectionWrapper */ .Uq, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ContentWrapper__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: [
                        !token && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                page === "signin" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoginView, {
                                    pageType: "standalone"
                                }),
                                page === "signup" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SignUpView, {
                                    pageType: "standalone"
                                }),
                                page === "reset-verification" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ResetView, {
                                    pageType: "standalone"
                                }),
                                page === "forgot-password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ForgotView, {
                                    pageType: "standalone"
                                }),
                                page === "email-verification" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VerifyView, {
                                    pageType: "standalone"
                                })
                            ]
                        }),
                        page === "signout" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Signout, {}),
                        page === "postlogin" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PostLogin, {
                            termPages: termPages
                        }),
                        page === "error" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ErrorView, {})
                    ]
                })
            })
        ]
    });
};
Auth.Layout = _components_Layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Auth);


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(97345)


/***/ }),

/***/ 12569:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ renderMetaTags; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function renderMetaTags(data) {
    return data.map(({ tag, attributes, content }) => {
        let key = [tag];
        if (attributes && 'property' in attributes) {
            key.push(attributes.property);
        }
        if (attributes && 'name' in attributes) {
            key.push(attributes.name);
        }
        if (attributes && 'rel' in attributes) {
            key.push(attributes.rel);
        }
        if (attributes && 'sizes' in attributes) {
            key.push(attributes.sizes);
        }
        const Tag = tag;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, Object.assign({ key: key.join('-') }, attributes), content));
    });
}
//# sourceMappingURL=renderMetaTags.js.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6427,9909,8448,6119,2293,1745,2062,120,9774,2888,179], function() { return __webpack_exec__(62504); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);